import { RichTextInput } from "ra-input-rich-text";
import { ArrayInput, AutocompleteInput, Edit, DateTimeInput,  FormDataConsumer, ReferenceInput, required, SelectInput, SimpleForm, SimpleFormIterator, TextInput } from "react-admin";
import { FileInput } from "../fileinputs/eventFileUpload";

export function ChildMomentEdit(props) {
    return (
        <Edit {...props}>
            <SimpleForm>
                <ReferenceInput source="childId" reference="child" >
                    <AutocompleteInput optionText="name" filterToQuery={searchText => ({ name: searchText })} validate={required()} />
                </ReferenceInput>
                <SelectInput source="type" choices={[
                    { id: "standard", name: "Standard" },
                    { id: "custom", name: "Custom" }
                ]} validate={required()} />
                <FormDataConsumer>
                    {({ formData, ...rest }) => {
                        if (formData.type === "custom") {
                            return <TextInput source="momentName" validate={required()} />
                        } else {
                            return (<ReferenceInput source="momentId" reference="moment" >
                                <AutocompleteInput optionText="name" filterToQuery={searchText => ({ name: searchText })} validate={required()} />
                            </ReferenceInput>)
                        }
                    }}
                </FormDataConsumer>
                <DateTimeInput source="momentTime" validate={required()} />
                <RichTextInput source="description" />
                <FileInput source="files" add edit title="Uploaded Files" route="childMoment/upload" />
                <ArrayInput source="tags">
                    <SimpleFormIterator>
                        <TextInput source="" validate={required()} />
                    </SimpleFormIterator>
                </ArrayInput>

            </SimpleForm>
        </Edit>
    )
}